module.exports = __webpack_public_path__ + "static/HeathcoteA-f43df0cc754d8398d0d744291efe3533.gif";